<template>
	<div>
		<Loader :show="loading" type="inline" />

		<div class="row row-xs" v-if="!loading && item">
			<div class="col col-12">
				<div class="card">
					<div class="card-body card-dash p-3">
						<div class="flex-grow-1">
							<GraphicSales title="Resumen de ventas" :data="salesData" />
						</div>
						<div class="data p-2">
							<div class="px-3  border-bottom">
								<h6>Cantidad vendidas</h6>
								<h4>{{ item.sold }}</h4>
							</div>
							<div class="px-3  border-bottom">
								<h6>Cantidad accesos</h6>
								<h4>{{ item.accesses }}</h4>
							</div>
							<div class="px-3 ">
								<h6>Total ingresos</h6>
								<h4>{{ item.currencySymbol }} {{ item.totalSales | toCurrency }}</h4>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- <div class="col col-md-8">
				<div class="row row-xs">
					<div class="col col-md-6">
						<div class="box">
							<div class="ico">
								<i class="icon icon-ticket-big"></i>
							</div>
							<div class="info">
								<h3>Entradas vendidas</h3>
								<p>{{ item.ticketsSold }} de {{ item.ticketsLimit }}</p>
							</div>
							<div>
								<vc-donut
									foreground="#f3f3f3"
									:size="60"
									unit="px"
									:thickness="22"
									:sections="[{ value: item.ticketsSoldPercent }]"
									:total="100"
									:start-angle="0"
									:auto-adjust-text-size="true"
								>
									<div style="font-size:15px">{{ item.ticketsSoldPercent }}%</div>
								</vc-donut>
							</div>
						</div>
					</div>

					<div class="col col-md-6">
						<div class="box">
							<div class="ico"><i class="icon icon-dollar"></i></div>
							<div class="info"><h3>Ventas</h3></div>
							<div>
								<h4>{{ item.currencySymbol }} {{ item.totalSales }}</h4>
							</div>
						</div>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>
<script>
import gql from "graphql-tag"
import GraphicSales from "@/components/GraphicSales"

export default {
	name: "MembershipDashboard",
	components: {
		GraphicSales
	},
	props: {
		id: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			item: null,
			loading: false,
			salesData: {
				series: [
					{
						name: "Ventas",
						data: [28, 29, 33, 36, 32, 32, 33]
					},
					{
						name: "Accesos",
						data: [200, 120, 87, 9, 120, 301, 202]
					}
				],
				xaxis: {
					categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"]
				},
				yaxis: {
					// title: { text: "Ventas"}
				}
			}
		}
	},
	async beforeMount() {
		this.loading = true
		this.item = await this.load()
		this.loading = false
	},
	methods: {
		async load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							membershipTypeSummary(id: $id) {
								mainChart {
									xaxis
									series {
										name
										type
										data
									}
								}
								sold
								limit
								sold
								soldPercent
								totalSales
								currency
								currencySymbol
								price
								accesses
							}
						}
					`,
					variables: { id: this.id },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					if (data.membershipTypeSummary.mainChart) {
						this.salesData.xaxis.categories = data.membershipTypeSummary.mainChart.xaxis
						this.salesData.series = data.membershipTypeSummary.mainChart.series
					}
					console.log(this.salesData)
					this.item = data.membershipTypeSummary
					return data.membershipTypeSummary
				})
				.catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss">
.card-dash {
	display: flex;

	.data {
		width: 240px;
		display: flex;
		flex-direction: column;
		flex-shrink: 0;

		& > div {
			flex-grow: 1;
			display: flex;
			flex-direction: column;
			justify-content: center;
		}
	}
}
</style>
